type BuildEnv = Record<string, string | boolean | undefined>;

/**
 * Retrieve an environment variable from either Vite or process-based builds.
 */
export default function getBuildEnv(name: string): string | undefined {
  const viteEnv = (import.meta.env || {}) as BuildEnv;

  if (typeof viteEnv[name] === 'string') {
    return viteEnv[name] as string;
  }

  if (typeof process !== 'undefined' && process.env && typeof process.env[name] === 'string') {
    return process.env[name];
  }

  return undefined;
}
